import { render, staticRenderFns } from "./DetailChartPanel.vue?vue&type=template&id=226d71ff&scoped=true&"
import script from "./DetailChartPanel.vue?vue&type=script&lang=js&"
export * from "./DetailChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailChartPanel.vue?vue&type=style&index=0&id=226d71ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d71ff",
  null
  
)

export default component.exports